import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, inject } from '@angular/core';
import { EditInfoDialogComponent } from '@components/profile-account/edit-info-dialog/edit-info-dialog.component';
import { UserDeleteDialogComponent } from "@components/recertification/user-delete-dialog/user-delete-dialog.component";
import { TranslocoModule } from '@ngneat/transloco';
import { firstValueFrom } from 'rxjs';
import iconLibrary from 'src/app/common/iconLibrary';
import { DialogService } from 'src/app/common/util/dialog-service';
import { Events } from 'src/app/util/events';
import { userInfoInputFields } from 'src/app/util/user-info-input-fields';
import { UserInfoInputConfig } from 'src/app/util/user-info-input-groupt';
import { ColleagueInfo, ColleaguesService, UserInfo } from 'src/openapi-client';

@Component({
  selector: 'wct-colleague-display',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './colleague-display.component.html',
  styleUrls: ['./colleague-display.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ColleagueDisplayComponent {
  @Input({ required: true }) public colleague!: ColleagueInfo;
  @Input({ required: true }) public editable!: boolean;

  protected readonly iconLibrary = iconLibrary;

  private readonly colleaguesService: ColleaguesService = inject(ColleaguesService);

  constructor(private readonly dialogService: DialogService) {}

  protected modifyUser(): void {
    if (!this.editable) {
      return;
    }

    this.dialogService.create(EditInfoDialogComponent, {
      saveAction: this.updateColleague,
      userInfo: this.colleague.userInfo,
      inputConfig: new UserInfoInputConfig([
        { titleI18n: userInfoInputFields.commonI18n, inputs: userInfoInputFields.common },
        { titleI18n: userInfoInputFields.personalI18n, inputs: userInfoInputFields.personal },
      ], userInfoInputFields.personalCombinedRequiredInputs),
    });
  }

  protected deleteUser(): void {
    if (!this.editable) {
      return;
    }

    this.dialogService.create(UserDeleteDialogComponent, {
      userInfo: this.colleague.userInfo
    });
  }

  private readonly updateColleague = async(modifiedUserInfo: UserInfo): Promise<void> => {
    await firstValueFrom(this.colleaguesService.updateColleague({ ...this.colleague, userInfo: modifiedUserInfo }));
    Events.colleaguesModified.next();
  }
}
